// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/patients-detail.less
// module id = 3803
// module chunks = 0